import React,{useEffect,useState} from 'react'
import articlesService from '../../../services/articles.service'
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

export default function ManageCategory() {
  const [warningDelete,setWarningDelete] = useState(false)
  const [toogleDelete,setToogleDelete] = useState(false)
  const [categoryList,setCategoryList] = useState([])
    const [data,setData] = useState()
    const {
        register,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
      } = useForm();

  useEffect(()=>{
    getCategory()
  },[])
const getCategory = ()=>{
    articlesService.getArticlesCategory()
    .then(res=>{
        setCategoryList(res.data)
       
       // console.log(newdata)
    })
    .catch(err=>{
        console.log(err)
    })
}
useEffect(()=>{
    const newdata = {
        id: "root",
        name: "Categories",
        children: convertToHierarchy(categoryList),
      };
    setData(newdata)
},[categoryList])
const convertToHierarchy = (array, parentId = 0) => {
  const result = [];

  array.forEach(item => {
    if (item.parentCategoryId === parentId) {
      const newItem = {
        id: item.id.toString(),
        name: item.title,
      };

      const children = convertToHierarchy(array, item.id);

      if (children.length > 0) {
        newItem.children = children;
      }

      result.push(newItem);
    }
  });

  return result;
};
  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

const onSubmit = (data)=>{
    articlesService.saveArticlesCategory(data)
    .then(res=>{
        toast.success("Category Added",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
        reset()
        getCategory()
    })
    .catch(err=>{
        toast.error('Error Adding Category',{
            position:toast.POSITION.BOTTOM_RIGHT
        })
        console.log(err)
    })
}

const onDeleteSubmit = (data)=>{

   const catId = data.categoryid;
  setWarningDelete(false)
   articlesService.deleteCategory(catId)
    .then(res=>{
      toast.success("Category Deleted",{
         position:toast.POSITION.BOTTOM_RIGHT
      })
      getCategory()
    })
    .catch(err=>{
        toast.error('Error Deleting Category',{
          position:toast.POSITION.BOTTOM_RIGHT
        })
        console.log(err)
    })
}

  return (
   <>
        <div className="pagetitle d-flex justify-content-between">
                  <h1>Article Categories</h1>
                  <div>
                  </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <div className="card mt-4">
                        <div className="card-title ps-3">Category List</div>
                         <div className="card-body">
                         {data && <Box sx={{ minHeight: 110, flexGrow: 1, maxWidth: 300 }}>
                            <TreeView
                                aria-label="rich object"
                                defaultCollapseIcon={<ExpandMoreIcon />}
                                defaultExpanded={['root']}
                                defaultExpandIcon={<ChevronRightIcon />}
                            >
                                {renderTree(data)}
                            </TreeView>
                        </Box> }
                        </div>
                    </div>
                </div>

                <div className="col-6">
                      <div className="card mt-4">
                        <div className="card-body">
                             <div className="card-title ps-3">Add Category</div>
                         <form onSubmit={handleSubmit(onSubmit)}>
                             <div className="form-group">
                                <label htmlFor="" className="form-label">Parent Category</label>
                                <select {...register("parentCategoryId")} className="form-select">
                                 {categoryList && categoryList.map((item,index)=>(
                                      <option key={index} value={item.id}>{item.title}</option>
                                  ))}
                                </select>
                             </div>
                             <div className="form-group mt-3 mb-3">
                               <label htmlFor="" className="form-label">Title</label>
                               <input type="text" className="form-control" {...register("title")}/>
                             </div>
                             <button className="btn btn-sm btn-success" type="submit"><i className="bi bi-floppy"></i> Save</button>
                             </form>
                        </div>
                      </div>
                      <div className="card mt-3">
                        <div className="card-body">
                          <div className="card-title ps-3">Delete Category</div>
                                  <form onSubmit={handleSubmit(onDeleteSubmit)}>
                                  <div className="from-group mb-3">
                                      <label htmlFor="" className="form-label">Select Category to Delete</label>
                                      <select {...register("categoryid")} className="form-select">
                                      {categoryList && categoryList.map((item,index)=>(
                                            <option key={index} value={item.id}>{item.id} - {item.title}</option>
                                        ))}
                                      </select>
                                  </div>
                                  {warningDelete ? 
                                  <div className="form-group mb-2">
                                    <label htmlFor="" className="form-label text-danger">Are you sure, delete category? Subcategories will become orphan if any. </label>
                                      <button className="btn btn-sm btn-danger me-2" type="submit" >Yes Continue</button>
                                      <button className="btn btn-sm btn-secondary" onClick={()=>setWarningDelete(false)}>Cancel</button>
                                  </div>
                                  : <div><button className="btn btn-sm btn-warning" onClick={()=>setWarningDelete(true)}>Delete Category</button></div>}
                                
                                  </form>
                        </div>
                      </div>
                </div>
            </div>
        </div>
   </>
  )
}
